export default "https://fiverr-res.cloudinary.com/npm-assets/layout-service/pro-favicon.60cc431.ico";